//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SEO from '~/mixins/SEO.js'
import JSONSCHEMA from '~/mixins/JSONSCHEMA.js'

export default {
  name: 'index',
  mixins: [SEO, JSONSCHEMA],
  data() {
    return {
      tagsList: [],
      currentPage: 1,
      categoryActive: '',
    }
  },

  methods: {
    async fetchTags(pageNumber) {
      if (this.currentPage != pageNumber) {
        this.$router.push({path: this.$route.path, query: {page: `${pageNumber}`}})
        const response = await this.$api.fetchSingleTag(this.$route.params.slug, pageNumber, '')
        this.tagsList = response.content.items
        var element = document.getElementsByClassName('right-side')[0];
        window.scrollTo(0, element.offsetTop - 150);
        this.currentPage = pageNumber

      }
    },

    async getCategoryTags(category) {
      if (this.categoryActive != category) {
        const response = await this.$api.fetchSingleTag(this.$route.params.slug, 1, null, category)
        this.tagsList = response.content.items
        this.categoryActive = category
        this.currentPage = this.$route.params.page ? this.$route.params.page : 1
        this.$router.push({path: this.$route.path, query: {page: `${this.currentPage}`}})
      }
    }
  },

  created() {
    this.tagsList = this.page.items
  },
  mounted() {
    if (this.$route && this.$route.query && this.$route.query.page) {
      this.currentPage = Number(this.$route.query.page)
    } else {
      this.currentPage = 1
    }
    this.$router.push({path: this.$route.path, query: {page: `${this.currentPage}`}})
  },

  asyncData(context) {
    return context.app.$api.fetchSingleTag(context.params.slug, context.query.page ? context.query.page : 1, '')
      .then(response => {
        return {
          page: response.content
        }
      })
      .catch(e => {
        context.error({statusCode: 404})
      })
  },
}
